import axios, { AxiosResponse } from 'axios';
import { getEndpointBase } from '../../services/api.service';
import { InternshipStatus } from './InternshipStatus.type';
import { PaginationResponse } from '../../types/pagination.types';

let listRequest: any = null;

export interface InternshipStatusResponse {
  data: InternshipStatus[];
  pagination: PaginationResponse;
}

export const internshipStatusService = {
  get(params?: {
    search?: string,
    page?: number | string;
    perPage?: number;
  }): Promise<
    AxiosResponse<InternshipStatusResponse>
  > {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();

    return axios.get(getEndpointBase(`internships/status`), {
      cancelToken: listRequest.token,
      params,
    });
  },
  create: (data: Omit<InternshipStatus, 'id'>): Promise<AxiosResponse<InternshipStatus>> => {
    return axios.post(getEndpointBase(`internships/status`), data);
  },
  update: (data: InternshipStatus): Promise<AxiosResponse<InternshipStatus>> => {
    return axios.put(getEndpointBase(`internships/status/${data.id}`), data);
  },
  delete: (id: number): Promise<AxiosResponse> => {
    return axios.delete(getEndpointBase(`internships/status/${id}`));
  },
}
